import { PATHS } from '@/constants/page-paths';

export const appLinks = {
  sections: [
    {
      title: 'Explore',
      links: [
        { label: 'Home', url: PATHS.HOME, key: 'home' },
        { label: 'Chat', url: PATHS.CHAT, key: 'chat' },
        { label: 'Studio', url: PATHS.TWIN_STUDIO, key: 'studio' },
        {
          label: 'Studio Videos',
          url: PATHS.TWIN_STUDIO_COLLECTION,
          key: 'studio_videos',
        },
      ],
    },
    {
      title: 'Your Account',
      links: [
        { label: 'Profile', url: PATHS.PROFILE, key: 'profile' },
        { label: 'My Twin', url: PATHS.MY_TWIN, key: 'my_twin' },
        { label: 'Get your Twin', url: PATHS.TWIN_LANDING, key: 'get_twin' },
        { label: 'Buy Twin Points', url: PATHS.BUY_POINTS, key: 'buy_points' },
      ],
    },
    {
      title: 'Support',
      links: [
        {
          label: 'Help & Feedback',
          url: PATHS.FEEDBACK,
          key: 'help_and_feedback',
        },
      ],
    },
  ],
};
